<template>
  <div class="content">
    <div class="answer_box">
      <div class="answer_card">
        <div class="card_top">
          <p class="title">答题卡</p>
          <div class="judg_box">
            <div>
              <img src="../../../assets/icon/paper_right01.png" alt="" />
              <span>{{ correctNumber }}</span>
            </div>
            <div>
              <img src="../../../assets/icon/paper_error01.png" alt="" />
              <span>{{ errorNumber }}</span>
            </div>
          </div>
        </div>
        <!-- <div v-for="(item, index) in testPaperModuleList" :key="index">
          <div class="card_title">
            {{ toCapital(index) }}、{{ item.moduleName }}
          </div> -->
        <div class="topic_list">
          <div
            v-for="(items, indexs) in paperList"
            :key="indexs"
            style="cursor: pointer"
            :class="
              items.userAnswer && items.isSubmit && items.isCorrect
                ? 'correct_box'
                : items.userAnswer && items.isSubmit && !items.isCorrect
                ? 'error_box'
                : ''
            "
            @click="current = indexs"
          >
            {{ indexs + 1 }}
          </div>
        </div>
        <!-- </div> -->
        <div class="btn_box">
          <el-button class="btn1" @click="exeClose()">暂时退出</el-button>
          <el-button type="primary" class="btn2" @click="exeSubmit()"
            >结束练习</el-button
          >
        </div>
      </div>
      <div class="answer_info">
        <multiple-choice
          :paper-data="paperList[index]"
          :current="current"
          :total="total"
          :index="index"
          :isErrorBook="true"
          @selected="selected"
          @prev="prev"
          @next="next"
          v-for="(item, index) in paperList"
          :key="index"
        ></multiple-choice>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  CreateAnswerRecord,
  submitAnswerPaperRecord,
} from "@/api/answer/answer.js";
import {
  gotQuestionExercise,
  delWrongQuestion,
} from "@/api/willingLearn/index.js";
import { paperGetToken } from "@/api/index/index";
import multipleChoice from "./components/multipleChoice.vue";
export default {
  components: {
    multipleChoice,
  },
  data() {
    return {
      testPaperId: "",
      paperPlatform: "out",
      aprId: "",
      paperList: [],
      testPaperModuleList: [],
      total: 0,
      current: 0,
      errorNumber: 0, //答错数量
      correctNumber: 0, //答对数量
      atNumber: 0, //第几题
      answerResults: "", //选择的答案
      questionId: "", //当前所作答的试题Id
      testPaperModuleCurrent: 0,
      testPaperModuleTotal: 0,
      goodId: "",
    };
  },
  mounted() {
    this.goodId = this.$route.query.goodId;
    this.current = Number(this.$route.query.errorBookIndex);
    this.getAnswerQuestions();
  },
  computed: {
    ...mapGetters(["name", "userId"]),
  },
  methods: {
    getAnswerQuestions() {
      paperGetToken().then((res) => {
        let data = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          questionType: this.$route.query.questionType,
          token: res.data,
          isDesc: this.$route.query.isDesc,
          goodId: this.goodId,
        };
        gotQuestionExercise(data).then((res) => {
          this.paperList = res.rows || [];
          this.total = this.paperList.length;
          this.paperList.map((item, index) => {
            // questionType:1单选、questionType:2多选、questionType:3判断类型试题
            this.$set(item, "isCorrect", false); //是否提交答案
            if (item.questionType == 1 || item.questionType == 2) {
              let list = [];
              JSON.parse(item.standardAnswer).map((items) => {
                list.push(items.title);
              });
              this.$set(item, "correctAnswer", list.toString()); //正确答案
            } else if (item.questionType == 3) {
              this.$set(
                item,
                "correctAnswer",
                JSON.parse(item.standardAnswer)[0]
              ); //正确答案
            }
            this.$set(item, "userAnswer", ""); //用户答案
            this.$set(item, "isSubmit", false); //是否提交答案
          });
        });
      });
    },
    GET_CURRENT_TIME() {
      let date = new Date();
      let y = date.getFullYear(); //年
      let m = date.getMonth() + 1; //月份
      let d = date.getDate(); //日
      let h = date.getHours(); //小时
      let f = date.getMinutes(); //分
      let s = date.getSeconds(); //秒
      let data =
        y +
        "-" +
        (m > 9 ? m : "0" + m) +
        "-" +
        (d > 9 ? d : "0" + d) +
        " " +
        (h > 9 ? h : "0" + h) +
        ":" +
        (f > 9 ? f : "0" + f) +
        ":" +
        (s > 9 ? s : "0" + s);
      return data;
    },
    // 单选、多选、判断选择答案回调
    selected(e) {
      console.log(e);
      this.paperList[this.current].userAnswer = e;
      this.answerResults = e;
    },
    // 上一题
    prev() {
      if (this.current > 0) {
        this.current--;
      } else {
        if (this.testPaperModuleCurrent > 0) {
          this.testPaperModuleCurrent--;
          this.getAnswerQuestions();
          this.current = this.total + 1;
        }
      }
    },
    // 下一题
    next() {
      if (
        this.paperList[this.current].userAnswer &&
        !this.paperList[this.current].isSubmit
      ) {
        this.createAnswerRecord();
      } else if (this.current != this.total - 1) {
        if (this.current < this.total - 1) {
          this.current++;
        }
      } else if (this.current == this.total - 1) {
        this.exeSubmit();
      }
    },
    judgmentAnswer(str1, str2) {
      let arr1 = [];
      let arr2 = [];
      // 把两个字符串分别用循环转换为数组
      for (let i = 0; i < str1.length; i++) {
        arr1.push(str1.charAt(i));
      }
      for (let i = 0; i < str2.length; i++) {
        arr2.push(str2.charAt(i));
      }
      // 将数组内元素排序，再转化为字符串比较
      if (arr1.sort().toString() == arr2.sort().toString()) {
        return true;
      } else {
        return false;
      }
    },
    toCapital(index) {
      let arr = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十"];
      return arr[index];
    },
    createAnswerRecord() {
      paperGetToken().then((res) => {
        CreateAnswerRecord({
          questionId: this.paperList[this.current].questionId,
          answerPlatform: this.paperPlatform,
          userId: this.userId,
          userName: this.name,
          paperId: this.testPaperId,
          answerDate: this.GET_CURRENT_TIME(),
          answerResults: this.answerResults,
          aprId: this.aprId,
          token: res.data,
        }).then((res) => {
          if (res.data.questionType == 1 || res.data.questionType == 2) {
            let list = [];
            JSON.parse(res.data.standardAnswer).map((item) => {
              list.push(item.title);
            });
            this.paperList[this.current].correctAnswer = list.toString();
          } else if (res.data.questionType == 3) {
            this.paperList[this.current].correctAnswer = JSON.parse(
              res.data.standardAnswer
            )[0];
          }
          this.paperList[this.current].analysis = res.data.analysis;

          this.paperList[this.current].isSubmit = true; //将答案和解析添加到数据中
          if (
            this.judgmentAnswer(
              this.paperList[this.current].userAnswer,
              this.paperList[this.current].correctAnswer
            )
          ) {
            this.paperList[this.current].isCorrect = true;
            this.correctNumber++;
            console.log(
              localStorage.getItem("automatically-remove"),
              typeof localStorage.getItem("automatically-remove")
            );
            if (localStorage.getItem("automatically-remove") == "true") {
              delWrongQuestion({
                questionIds: res.data.id,
              });
            }
          } else {
            this.paperList[this.current].isCorrect = false;
            this.errorNumber++;
          }
        });
      });
    },
    // 暂时退出
    exeClose() {
      this.$confirm("是否要暂时退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$router.go(-1);
      });
    },
    // 结束练习
    exeSubmit() {
      this.$confirm("是否要结束练习?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        paperGetToken().then((res) => {
          this.$router.go(-1);
        });
      });
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  background-color: #f2f2f2;
  display: flex;
  justify-content: center;
  .answer_box {
    display: flex;
    align-items: flex-start;
    margin: 37px auto;
    .answer_card {
      width: 304px;
      background-color: #fff;
      margin-right: 16px;
      padding-bottom: 32px;
      .card_top {
        padding: 18px 20px 18px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .title {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          position: relative;
        }
        .title::before {
          content: "";
          width: 4px;
          height: 22px;
          position: absolute;
          left: -10px;
          background-color: #2e9adb;
        }
        .judg_box {
          width: 90px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          div {
            display: flex;
            align-items: center;
            span {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
            }
            img {
              width: 16px;
              height: 16px;
              margin-right: 6px;
            }
          }
        }
      }
      .card_title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        padding: 0 20px 20px 30px;
      }
      .topic_list {
        display: grid;
        width: 288px;
        border-bottom: 1px solid #f2f2f2;
        padding: 0 22px 20px 22px;
        margin: 0 auto 20px;
        box-sizing: border-box;
        grid-row-gap: 9px;
        grid-column-gap: 15px;
        justify-content: start;
        grid-template-columns: repeat(auto-fit, 21px);

        div {
          width: 21px;
          height: 21px;
          background: #ffffff;
          border: 1px solid #999999;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .correct_box {
          background: #70b603;
          color: #fff;
        }
        .error_box {
          background: #d9001b;
          color: #fff;
        }
      }
      .btn_box {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        button {
          width: 121px;
          height: 41px;
          border-radius: 6px;
        }
        .btn1 {
          border: 1px solid #2e9adb;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #2e9adb;
        }
        .btn2 {
          background: #2e9adb;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
    .answer_info {
      width: 1080px;
      min-height: 720px;
      padding-bottom: 20px;
      background-color: #fff;
    }
  }
}
</style>
